import { render } from "./AfterSalesRefundsReturn.vue?vue&type=template&id=1518c581&scoped=true&ts=true"
import script from "./AfterSalesRefundsReturn.vue?vue&type=script&lang=ts"
export * from "./AfterSalesRefundsReturn.vue?vue&type=script&lang=ts"

import "./AfterSalesRefundsReturn.vue?vue&type=style&index=0&id=1518c581&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1518c581"]])

export default __exports__